import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const repollAndMarkGrocery = async ({
  orderId,
  isRescanCanceledGrocery,
}: {
  orderId: string;
  isRescanCanceledGrocery?: boolean;
}) => {
  const response = await mutationExecute({
    variables: {
      orderId,
      isRescanCanceledGrocery,
    },
    mutation: graphql(`
      mutation RepollAndMarkGrocery($orderId: String!, $isRescanCanceledGrocery: Boolean) {
        repollAndMarkGrocery(orderId: $orderId, isRescanCanceledGrocery: $isRescanCanceledGrocery) {
          id
          status
        }
      }
    `),
  });

  return response.data?.repollAndMarkGrocery;
};
